import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import {
  Text,
  FormControl,
  FormLabel,
  Button,
  Flex,
  useToast,
  Input,
} from '@chakra-ui/react';
import StoresApi from '../../../../../../api/stores';
import PinCodeApi from 'api/pincode';
import { useAuth } from '../../../../../../auth-context/auth.context';
import Card from 'components/card/Card';
import SelectField from '../../../../../../components/formComponents/selectField.js';
import InputField from '../../../../../../components/formComponents/inputField.js';
import UpperCaseChange from 'components/formComponents/upperCaseChange.js';
import { useHistory } from 'react-router-dom';
import { CreateStoreFormValidationSchema } from 'formValidations/createStoreFormValidations';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';

export default function StoreForm(props) {
  const history = useHistory();
  const { user } = useAuth();
  const toast = useToast();
  const toastIdRef = React.useRef();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const operationLocationsList = props?.operationLocationsList;
  const companiesList = props?.companiesList;
  const operationLocationIdFromProps = props?.operationLocationId;
  const companyIdFromProps = props?.companyId;
  const { getPermissionsForModule } = usePermissions();
  const [storePermissions, setStorePermissions] = useState(null);

  useEffect(() => {
    const variantStorePermissions = getPermissionsForModule([Modules.Store]);
    setStorePermissions(variantStorePermissions);
  }, []);

  const companyNamePlaceHolder = companiesList.reduce((acc, curr) => {
    if (curr.id === companyIdFromProps) {
      acc = curr.name;
    }
    return acc;
  }, 'Select Parent Company of Branch.');

  const operationlocationNamePlaceHolder = operationLocationsList.reduce(
    (acc, curr) => {
      if (curr.id === operationLocationIdFromProps) {
        acc = curr.name;
      }
      return acc;
    },
    'Select Operation Location of Branch.'
  );

  const [inpDisable, setInpDisable] = useState(true);

  console.log('Permissions', storePermissions);

  const initialValues = {
    operationLocationId: operationLocationIdFromProps || '',
    companyId: companyIdFromProps || '',
    name: '',
    storeCode: '',
    goldLocker: false,
    savingPlan: false,
    email: '',
    phoneNumber: '',
    countryCode: '+91',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    landmarks: '',
    pincode: '',
    status: 'ACTIVE',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      let response = await StoresApi.Create(values);
      response = response.data;
      if (response.status_code === 200) {
        toastIdRef.current = toast({
          title: response.message || 'Successfully Added',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        history.push('/admin/company', { companyId: companyIdFromProps });
      } else {
        toastIdRef.current = toast({
          title: response.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      toastIdRef.current = toast({
        title: 'Unable to Add',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  const GetPincode = async (e, setFieldValue) => {
    console.log('GetPincode called', e);

    try {
      let response = await PinCodeApi.Get({ pincode: e });
      response = response.data;
      console.log(response);
      if (
        response.status_code === 200 &&
        Object.keys(response.data).length !== 0
      ) {
        setFieldValue('country', response.data.country);
        setFieldValue('state', response.data.state);
        setFieldValue('city', response.data.city);
        setInpDisable(false);
      } else {
        toastIdRef.current = toast({
          title:
            'Pincode not found! Please recheck pincode or fill City, State and Country manually.',
          status: 'warning',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        setInpDisable(false);
      }
    } catch (error) {
      console.log('Here is Error', error);
      setInpDisable(false);
    }
  };

  console.log('Store permissions', storePermissions);
  if (!storePermissions?.read) {
    return <NoPermissionsMessage module={Modules.Store} />;
  }

  return (
    <Flex direction='column' mt={20} mx={5}>
      <Flex alignItems='center' justifyContent='space-between' mt={10} mb={10}>
        <Text fontSize='3xl' fontWeight='400'>
          Add New Branch
        </Text>
      </Flex>

      <Formik
        initialValues={initialValues}
        validationSchema={CreateStoreFormValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form noValidate>
            <Flex direction='column'>
              <Flex
                direction={{ base: 'column', md: 'column', lg: 'row' }}
                justifyContent='space-between'
                gap={2}
              >
                {operationLocationIdFromProps ? (
                  <>
                    <Flex direction='column' mt={6} width='100%'>
                      <FormLabel>
                        <Text fontSize='md' fontWeight='50'>
                          Under Operation Location:
                        </Text>
                      </FormLabel>
                      <Input
                        mt={-1}
                        disabled
                        bgColor='gray.200'
                        variant='auth'
                        type='Text'
                        placeholder={operationlocationNamePlaceHolder}
                      />
                    </Flex>
                  </>
                ) : (
                  <SelectField
                    label='Under Operation Location:'
                    required={true}
                    name='operationLocationId'
                    placeholder='Select Operation Location of Branch'
                    options={operationLocationsList.map((location) => ({
                      value: location.id,
                      label: location.name,
                    }))}
                  />
                )}

                {companyIdFromProps ? (
                  <>
                    <Flex direction='column' mt={6} width='100%'>
                      <FormLabel>
                        <Text fontSize='md' fontWeight='50'>
                          Under Company:
                        </Text>
                      </FormLabel>
                      <Input
                        mt={-1}
                        disabled
                        bgColor='gray.200'
                        variant='auth'
                        type='Text'
                        placeholder={companyNamePlaceHolder}
                      />
                    </Flex>
                  </>
                ) : (
                  <SelectField
                    label='Under Company:'
                    required={true}
                    name='companyId'
                    placeholder='Select Parent Company of Branch'
                    options={companiesList.map((company) => ({
                      value: company.id,
                      label: company.name,
                    }))}
                  />
                )}
              </Flex>
              <Card mt={5}>
                <Flex
                  direction={{ base: 'column', md: 'column', lg: 'row' }}
                  gap={2}
                >
                  <Flex width='100%'>
                    <InputField
                      label='Name of the Branch'
                      required={true}
                      name='name'
                      type='text'
                      placeholder='Branch Name in 80 characters'
                      maxLength='80'
                    />
                  </Flex>

                  <Flex minWidth='240px'>
                    <SelectField
                      label='Advance Book'
                      required={true}
                      name='goldLocker'
                      options={[
                        { value: true, label: 'Enable' },
                        { value: false, label: 'Disable' },
                      ]}
                    />
                  </Flex>
                  <Flex minWidth='240px'>
                    <SelectField
                      label='Saving Plan'
                      required={true}
                      name='savingPlan'
                      options={[
                        { value: true, label: 'Enable' },
                        { value: false, label: 'Disable' },
                      ]}
                    />
                  </Flex>
                </Flex>

                <Flex
                  direction={{ base: 'column', md: 'column', xl: 'row' }}
                  gap={2}
                >
                  <Flex
                    direction={{ base: 'column', md: 'column', lg: 'row' }}
                    gap={2}
                    width='100%'
                  >
                    <InputField
                      label='E-Mail Address'
                      required={true}
                      width={{ base: 'none', md: 'none', lg: 'sm', xl: 'md' }}
                      name='email'
                      type='email'
                      placeholder='example@somewhere.com'
                      maxLength='100'
                    />

                    <InputField
                      label='Phone Number'
                      required={true}
                      minWidth='240px'
                      name='phoneNumber'
                      type='number'
                      placeholder='10 Digit Number'
                      maxLength='10'
                    />
                  </Flex>

                  <Flex
                    direction={{ base: 'column', md: 'column', lg: 'row' }}
                    gap={2}
                    width='100%'
                  >
                    <SelectField
                      label='Status'
                      required={true}
                      name='status'
                      options={[
                        { value: 'ACTIVE', label: 'Active' },
                        { value: 'INACTIVE', label: 'Inactive' },
                      ]}
                    />

                    <InputField
                      label='Store Code'
                      required={true}
                      name='storeCode'
                      type='text'
                      onChange={UpperCaseChange}
                    />
                  </Flex>
                </Flex>
              </Card>

              <Text mt={12} fontSize='xl' fontWeight='700'>
                Postal Address :
              </Text>

              <Card mt={4}>
                <Flex
                  direction={{
                    base: 'column',
                    md: 'column',
                    lg: 'row',
                  }}
                  gap={2}
                >
                  <InputField
                    label='Address Line 1'
                    required={true}
                    name='addressLine1'
                    type='text'
                    placeholder='Upto 100 Characters'
                    maxLength='100'
                  />
                  <InputField
                    label='Address Line 2'
                    name='addressLine2'
                    type='text'
                    placeholder='Upto 100 Characters'
                    maxLength='100'
                  />
                </Flex>

                <Flex
                  direction={{ base: 'column', md: 'column', lg: 'row' }}
                  justifyContent='space-between'
                  gap={2}
                >
                  <InputField
                    label='Landmarks'
                    required={true}
                    name='landmarks'
                    type='text'
                    placeholder='Upto 80 Characters'
                    maxLength='80'
                  />
                  <InputField
                    label='Pincode'
                    required={true}
                    name='pincode'
                    type='text'
                    placeholder='Area Pincode'
                    maxLength='40'
                    onChange={(e) => {
                      setFieldValue('pincode', e.target.value);
                      e.target.value.length === 6 &&
                        GetPincode(e.target.value, setFieldValue);
                    }}
                  />
                </Flex>
                <Flex
                  direction={{ base: 'column', md: 'column', lg: 'row' }}
                  justifyContent='space-between'
                  gap={2}
                >
                  <InputField
                    label='City'
                    required={true}
                    name='city'
                    type='text'
                    placeholder='Upto 40 Characters'
                    variant='auth'
                    bgColor={inpDisable ? 'gray.200' : ''}
                    disabled={inpDisable}
                  />
                  <InputField
                    label='State'
                    required={true}
                    name='state'
                    type='text'
                    placeholder='Upto 40 Characters'
                    variant='auth'
                    bgColor={inpDisable ? 'gray.200' : ''}
                    disabled={inpDisable}
                  />
                  <InputField
                    label='Country'
                    required={true}
                    name='country'
                    type='text'
                    placeholder='Upto 40 Characters'
                    variant='auth'
                    bgColor={inpDisable ? 'gray.200' : ''}
                    disabled={inpDisable}
                  />
                </Flex>
              </Card>

              <FormControl mt={20}>
                <Button colorScheme='blue' type='submit'>
                  Add New Branch
                </Button>
              </FormControl>
            </Flex>
          </Form>
        )}
      </Formik>
    </Flex>
  );
}
